// eslint-disable-next-line max-classes-per-file
class Node<T> {
  value: T

  next: Node<T>

  previous: Node<T>

  constructor(value: T, next?: Node<T>, previous?: Node<T>) {
    this.value = value
    this.next = next || null
    this.previous = previous || null
  }
}

export class Stack<T> {
  private head: Node<T>

  private tail: Node<T>

  size: number

  constructor() {
    this.head = null
    this.tail = null
    this.size = 0
  }

  public clear = (): void => {
    this.head = null
    this.tail = null
    this.size = 0
  }

  public isEmpty = (): boolean => {
    return this.size === 0
  }

  public push = (value: T): void => {
    const node = new Node(value)
    if (this.size === 0) {
      this.head = node
      this.tail = node
    } else {
      this.tail.next = node
      node.previous = this.tail
      this.tail = node
    }
    this.size += 1
  }

  public pop = (): T => {
    if (this.size === 0) {
      throw new Error('Stack is Empty')
    }
    const node = this.tail
    if (node.previous === null) {
      this.head = null
      this.tail = null
    } else {
      node.previous.next = null
      this.tail = node.previous
    }
    this.size -= 1
    return node.value
  }

  public peek = (): T => {
    if (this.size === 0) {
      throw new Error('Stack is Empty')
    }
    return this.tail.value
  }

  public removeBottom = (): T => {
    if (this.size === 0) {
      throw new Error('Stack is Empty')
    }
    const node = this.head
    if (node.next === null) {
      this.head = null
      this.tail = null
    } else {
      node.next.previous = null
      this.head = node.next
    }
    this.size -= 1
    return node.value
  }
}
